import { Popover } from '@headlessui/react';
import { IconChevronRight } from 'components/icons';
import { IconNotification } from 'components/icons/IconNotification';
import { SITE_MAP } from 'globalConstants';
import {
  MARK_NOTIFICATIONS_AS_READ,
  MarkNotificationsAsReadData,
  MarkNotificationsAsReadVariables,
} from 'graphql/main/mutations/temp/mark-notification-as-read';
import {
  MY_NOTIFICATIONS,
  MyNotificationsData,
  MyNotificationsVariables,
} from 'graphql/main/queries/temp/get-list-notification';
import { useFlexMutation, useFlexQuery } from 'hooks';
import { gt, isEmpty, map } from 'lodash';
import { useRouter } from 'next/router';
import { useState } from 'react';
import NotificationPart, { NotificationSkeleton } from '../../../notification-part';

const DEFAULT_LIMIT_NOTIFICATION = 10;
const DEFAULT_SKELETON_NOTIFICATION = 10;

const NotificationPopover = () => {
  const { push } = useRouter();
  const [countUnread, setCountUnread] = useState('');
  const { data: myNotificationsData, loading: loadingMyNotifications } = useFlexQuery<
    MyNotificationsData,
    MyNotificationsVariables
  >('main', MY_NOTIFICATIONS, {
    variables: {
      limit: DEFAULT_LIMIT_NOTIFICATION,
    },
    onCompleted: (data) => {
      setCountUnread(
        gt((data.myNotifications?.statistics as any)?.all, 99)
          ? '99+'
          : gt((data.myNotifications?.statistics as any)?.all, 0)
          ? `${(data.myNotifications?.statistics as any)?.all}`
          : '',
      );
    },
  });
  const { items: myNotifications } = myNotificationsData?.myNotifications ?? {};
  const [markNotificationsAsRead] = useFlexMutation<
    MarkNotificationsAsReadData,
    MarkNotificationsAsReadVariables
  >('main', MARK_NOTIFICATIONS_AS_READ);

  const markReadAll = async () => {
    await markNotificationsAsRead({
      variables: {
        isReadAll: true,
      },
    });
  };
  const viewAll = async () => {
    push(`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.NOTIFICATION}`);
  };

  return (
    <Popover className='relative h-[24px]'>
      <Popover.Button type='button' className='relative'>
        <IconNotification className='h-[24px] w-[24px] text-primary' />
        {!isEmpty(countUnread) && (
          <span className='absolute top-[-4px] right-[-4px] flex min-h-[24px] min-w-[24px] items-center justify-center rounded-full border border-paper bg-badge text-[9px] leading-[11px] text-paper'>
            {countUnread}
          </span>
        )}
      </Popover.Button>
      <Popover.Panel className='absolute right-[-40px] top-[40px] flex flex-col max-h-[calc(100vh-64px)] w-[382px] space-y-[12px] rounded-[8px] bg-paper py-[16px] shadow-8'>
        <div className='flex flex-col space-y-[12px] px-[12px] overflow-y-auto'>
          <span className='text-[18px] leading-[23px] font-[600]'>Thông báo</span>
          <div className='flex justify-end'>
            <button type='button' onClick={markReadAll}>
              <span className='text-[12px] leading-[15px] font-[600] text-primary'>
                Đánh dấu đã đọc tất cả
              </span>
            </button>
          </div>
          <div className='flex flex-col'>
            {loadingMyNotifications
              ? map(Array(DEFAULT_SKELETON_NOTIFICATION).fill({}), (_, skeletonIndex) => (
                  <div key={skeletonIndex}>
                    <NotificationSkeleton />
                  </div>
                ))
              : map(myNotifications, (myNotification, myNotificationsIndex) => (
                  <div key={`${myNotification.id}-${myNotificationsIndex}`}>
                    <NotificationPart notification={myNotification} />
                  </div>
                ))}
          </div>
        </div>
        <div className='h-[1px] w-full bg-stroke'></div>
        <div className='flex items-center justify-center'>
          <button type='button' className='flex text-primary space-x-[2px]' onClick={viewAll}>
            <span className='font-[600]'>Xem tất cả</span>
            <IconChevronRight className='h-[18px] w-[18px]' />
          </button>
        </div>
      </Popover.Panel>
    </Popover>
  );
};

export default NotificationPopover;
